module.exports = __webpack_public_path__ + "static/logo_white-6709646e5df380debbf2035af1c7a90a.svg";